import axiosClient from "@/lib/axiosClient"
import type { AppConfig } from "@/types"
import { useQuery } from "@tanstack/react-query"
import { useCurrentUser } from "./useCurrentUser"

export const ADMIN_APPS_QUERY_KEY = ["app_invalidate"]

export const fetchApps = async () => {
  const res = await axiosClient.get<AppConfig[]>(`/auth/apps/`)
  return res.data
}

export const useApps = () => {
  const currentUserQuery = useCurrentUser()

  const appsQuery = useQuery({
    queryKey: ["apps"],
    queryFn: fetchApps,
    enabled: !currentUserQuery.data,
  })

  return {
    ...appsQuery,
    data: currentUserQuery.data?.apps ?? appsQuery.data,
    isLoading: currentUserQuery.isLoading || appsQuery.isLoading,
    isError: currentUserQuery.isError || appsQuery.isError,
    error: currentUserQuery.error ?? appsQuery.error,
  }
}

export const useAdminApps = () =>
  useQuery({
    queryKey: ADMIN_APPS_QUERY_KEY,
    queryFn: fetchApps,
  })
